import { render, staticRenderFns } from "./NewsroomItemDisplay.vue?vue&type=template&id=5a3a0f6c&"
import script from "./NewsroomItemDisplay.vue?vue&type=script&lang=js&"
export * from "./NewsroomItemDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3a0f6c')) {
      api.createRecord('5a3a0f6c', component.options)
    } else {
      api.reload('5a3a0f6c', component.options)
    }
    module.hot.accept("./NewsroomItemDisplay.vue?vue&type=template&id=5a3a0f6c&", function () {
      api.rerender('5a3a0f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/Newsroom/Components/NewsroomItemDisplay.vue"
export default component.exports